import { useQuery } from "@tanstack/react-query";
import { apiFetch, ApiClientError } from "@/lib/api-client";
import { queryKeys } from "@/lib/query-keys";
import type {
  NotificationEngagementSummary,
  TimeRangeKey,
} from "@colab/shared";

export function useNotificationEngagement(range: TimeRangeKey) {
  return useQuery<NotificationEngagementSummary, ApiClientError>({
    queryKey: queryKeys.portal.analytics.notifications(range),
    queryFn: () =>
      apiFetch<NotificationEngagementSummary>(
        `/portal/analytics/notifications?range=${range}`,
      ),
  });
}
